import Papa from 'papaparse';

export const download = (content: string, filename: string, options = {}) => {
    const a = document.createElement('a');
    const blob = new Blob([content], options);
    const url = URL.createObjectURL(blob);

    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    a.click();

    URL.revokeObjectURL(url);
};

const HEIF_BRANDS = ['heic', 'heix', 'hevc', 'hevx', 'mif1', 'msf1'];

export const isHeic = async (file: Blob): Promise<boolean> => {
    const header = new Uint8Array(await file.slice(0, 12).arrayBuffer());
    const decoder = new TextDecoder();

    return (
        'ftyp' === decoder.decode(header.subarray(4, 8)) && HEIF_BRANDS.includes(decoder.decode(header.subarray(8, 12)))
    );
};

export const prepareCsv = (fields: Array<string>, data: Array<object>) => {
    return Papa.unparse(
        {
            fields: fields,
            data: data,
        },
        { escapeFormulae: true }
    );
};
